import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import mHijri from 'moment-hijri';
import { HomeService } from '../../pages/home/home.service';
import { inject } from '@angular/core';

@Component({
  selector: 'app-top-nav',
  imports: [TranslateModule, CommonModule],
  templateUrl: './top-nav.html',
  styleUrl: './top-nav.scss',
})
export class TopNav {
  public isAuthenticated!: Observable<boolean>;
  public isMobile$!: Observable<boolean>;
  private _homeService = inject(HomeService);
  complexInfo$ = this._homeService.getComplexInfo();
  constructor(private translate: TranslateService) {
  }
  // menuID = MenuID.PUBLIC;
  // maxMobileWidth = WidthCategory.SM;
  today = new Date();
  lang: string = 'en';
  dateArabic: Date = new Date();
  timeArabic: Date = new Date();
  isOpen: boolean = false;
  location: string = '';
  currentDate = new Date();
  hijriDate: string = '';

  toggleTopList() {
    this.isOpen = !this.isOpen;
  }
  ngOnInit(): void {
    this.hijriDate = mHijri(this.currentDate).format('iDD-iMMMM-iYYYY');
    console.log(this.isEnglish);
  }
  public toggleNavbar(): void {
    // this.menuService.toggleMenu(this.menuID);
  }
  isHowCheckOpen: boolean = false;
  toggleHowCheck() {
    this.isHowCheckOpen = !this.isHowCheckOpen;
  }

  get isEnglish() {
    return this.translate.getCurrentLang() === 'en';
  }
  goToLink(url?: string) {
    window.open(
      url || 'https://raqmi.dga.gov.sa/platforms/platforms/9ae2119a-6371-4247-5cae-08dd2d4c5423/platform-license',
      '_blank'
    );
  }




}
